import { SnModel } from './model';

export class SnCollection<T extends SnModel & { id: string }> extends Array<T> {
  constructor(...items: T[]) {
    super(...items);

    // Set the prototype explicitly
    Object.setPrototypeOf(this, SnCollection.prototype);
  }

  public clear(): void {
    this.length = 0;
  }

  public get(id: string): T {
    return this.find((item) => item.id === id);
  }

  public has(id: string): boolean {
    return !!this.get(id);
  }

  public setUp(...items: T[]): void {
    items.forEach((item) => {
      const updateItem = this.get(item.id);

      if (updateItem) {
        const index = this.indexOf(updateItem);
        this.splice(index, 1, item);
      } else {
        this.unshift(item);
      }
    });
  }

  public set(...items: T[]): void {
    items.forEach((item) => {
      const updateItem = this.get(item.id);

      if (updateItem) {
        const index = this.indexOf(updateItem);
        this.splice(index, 1, item);
      } else {
        this.push(item);
      }
    });
  }

  public delete(...items: T[]): void {
    items.forEach((item) => {
      const deleteItem = this.get(item.id);

      if (deleteItem) {
        const index = this.indexOf(deleteItem);
        this.splice(index, 1);
      }
    });
  }
}
